import { Box, styled } from '@mui/material';

export const FooterInfoWrapper = styled(Box)(() => ({
  display: 'flex',
  columnGap: '20px',
  flex: 1,
}));

export const FooterIconWrapper = styled(Box)(() => ({
  flexShrink: 0,
}));
